import React from 'react';
import { Pencil, Trash } from '@phosphor-icons/react';
import { OverflowWrapper } from 'app/components';

export const COLUMN_CONFIG = [
  {
    'label': 'Venue Name',
    'path': 'venueName',
    'order': 1,
    'field': 'venueName',
  },
  {
    'label': 'Venue Address',
    'path': 'venueAddress',
    'order': 2,
    'field': 'venueAddress',
  },
  {
    'label': 'Venue City',
    'path': 'venueCityName',
    'order': 3,
    'field': 'venueCityName',
  },
  {
    'label': 'Map URL',
    'path': 'googleMapURI',
    'order': 4,
    'field': 'googleMapURI',
    rowElement: ({ row }) => (
      <a className="underline underline-offset-4"
        target="_blank"
        rel="noreferrer"
        href={row?.googleMapURI}><OverflowWrapper>{row?.googleMapURI}</OverflowWrapper></a>
    ),
  },
  {
    'label': '',
    'path': 'action_items',
    'order': 5,
    'field': 'action_items',
  },
];

export const ACTION_ITEMS = [
  { icon: <Pencil />, action: 'edit' },
  { icon: <Trash />, action: 'delete' },
];
